// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parameter-block-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-height: 300px;
    padding: 5px 10px;
}

.parameter-block-container:has(.parameter-select-container) { /*Gross, why do selects have wierd padding*/
    padding: 5px;
}

.parameter-block-container > label {
    width: 100%;
}

.parameter-field-container {
    width: calc(50% - 10px);
    min-width: 200px;
}

.parameter-field-container label {
    padding-top: 0px;
    font-weight: normal;
}

.parameter-select-container {
    width: 100%;
}

@media screen and (max-width: 450px) {
    .parameter-field-container {
        width: 100%;
    }
}

`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLParameters/ECLParameters.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,8DAA8D,2CAA2C;IACrG,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".parameter-block-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    max-height: 300px;\r\n    padding: 5px 10px;\r\n}\r\n\r\n.parameter-block-container:has(.parameter-select-container) { /*Gross, why do selects have wierd padding*/\r\n    padding: 5px;\r\n}\r\n\r\n.parameter-block-container > label {\r\n    width: 100%;\r\n}\r\n\r\n.parameter-field-container {\r\n    width: calc(50% - 10px);\r\n    min-width: 200px;\r\n}\r\n\r\n.parameter-field-container label {\r\n    padding-top: 0px;\r\n    font-weight: normal;\r\n}\r\n\r\n.parameter-select-container {\r\n    width: 100%;\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n    .parameter-field-container {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
